export default "__VITE_ASSET__88f7679e__"